import React from "react";
import { Reveal, Eyebrow } from "./Decorative";
import ReelEmbed from "./ReelEmbed";
import { ANTARA_IG, GALLERY_IMAGES } from "../lib/constants";
import { trackInstagramClick } from "../lib/track";
import { Instagram } from "lucide-react";

// Canonical reel URLs (tracking ?igsh= params stripped).
const REELS = [
  { url: "https://www.instagram.com/reel/DbS-rdhPuen/", poster: GALLERY_IMAGES[5], posterSize: [1400, 933], alt: "An Antara bhajan jamming evening — Instagram reel" },
  { url: "https://www.instagram.com/reel/DavE5MfNUoc/", poster: GALLERY_IMAGES[6], posterSize: [1400, 933], alt: "The room singing together at an Antara evening — Instagram reel" },
  { url: "https://www.instagram.com/reel/DZxUC8jtCNI/", poster: GALLERY_IMAGES[7], posterSize: [1400, 2100], alt: "Live bhajan jamming with Antara — Instagram reel" },
];

export default function ReelStrip({ id = "reels", lead }) {
  return (
    <section id={id} className="bg-ivory-2 py-24 md:py-32 px-6 scroll-mt-24" data-testid="reels-section">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          {lead ? (
            <p className="text-center max-w-2xl mx-auto font-serif-italic text-2xl md:text-3xl text-amber leading-snug">
              {lead}
            </p>
          ) : (
            <div className="text-center max-w-2xl mx-auto">
              <Eyebrow>On Instagram</Eyebrow>
              <h2 className="mt-4 font-display text-4xl md:text-5xl text-ink">Moments from the evenings</h2>
              <p className="mt-5 font-body text-base md:text-lg text-ink-2/85 leading-relaxed">
                A few reels from past Antara evenings. Tap to play — the videos load only when you ask.
              </p>
            </div>
          )}
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8 max-w-3xl sm:max-w-none mx-auto">
          {REELS.map((r, i) => (
            <Reveal key={r.url} delay={i * 0.1}>
              <div className="mx-auto w-full max-w-[320px]">
                <ReelEmbed url={r.url} poster={r.poster} posterSize={r.posterSize} alt={r.alt} />
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-12 text-center">
            <a href={ANTARA_IG} target="_blank" rel="noopener noreferrer" onClick={trackInstagramClick} className="inline-flex items-center gap-2 font-body text-sm tracking-wide text-ink hover:text-gold transition">
              <Instagram size={15} /> Follow @antara.live
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
